import script from "./numberCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./numberCounter.vue?vue&type=script&setup=true&lang=js"

import "./numberCounter.vue?vue&type=style&index=0&id=54c6a7e6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c6a7e6"]])

export default __exports__